import { ChannelsRepository } from '@core/repositories/channels.repository';
import { Channel } from '@shared/interfaces/channel';
import { Observable, of, throwError } from 'rxjs';

interface ResultChannels {
  id: string;
  attributes: {
    name: string;
  };
  relationships: {
    status: {
      id: string;
      name: string;
    };
  };
}

export class FakeChannelsRepository implements ChannelsRepository {
  url: string;

  dataChannels: Array<ResultChannels> = [
    {
      id: '301',
      attributes: {
        name: 'Canal1'
      },
      relationships: {
        status: {
          id: '301',
          name: 'Estado1'
        }
      }
    },
    {
      id: '401',
      attributes: {
        name: 'Canal2'
      },
      relationships: {
        status: {
          id: '301',
          name: 'Estado1'
        }
      }
    },
    {
      id: '501',
      attributes: {
        name: 'Canal3'
      },
      relationships: {
        status: {
          id: '401',
          name: 'Estado2'
        }
      }
    }
  ];

  channels = {
    data: this.dataChannels
  };

  getItems(): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(this.channels);
  }

  add(channel: Channel): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }

  edit(channel: Channel): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }

  delete(item: any): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }
}
